import { ErrorPage, PageLayout } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

import { useGetBackOfficeListSubscriptionPackagesQuery } from "../../../api/subscription-packages.generated";
import { ParamId } from "../../../enums/types";
import { makeRoute } from "../../../hooks/route";
import { AllRoutes } from "../../route/Route";
import { SubscriptionPackageDetailPageContent } from "../organisms/SubscriptionPackageDetailPageContent";

export function SubscriptionPackageDetailPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id }: ParamId = useParams();
  const { currentData, isFetching, isError } =
    useGetBackOfficeListSubscriptionPackagesQuery(
      { size: 100 },
      { refetchOnMountOrArgChange: true }
    );

  const subscriptionPackage = currentData?.items?.find(
    (item) => item.id === id
  );

  const notFound = !isFetching && !subscriptionPackage;

  return isError || notFound ? (
    <ErrorPage
      errorMessageText={t("app.page.error.page.not.found")}
      messageForUser={t("app.page.error.defaultMessage")}
      hasGoBackButton
      buttonText={t("app.goToDasboard")}
      onButtonClick={() => navigate(makeRoute(AllRoutes.DASHBOARD))}
    />
  ) : (
    <PageLayout title={t("app.page.subscriptions.heading")}>
      <SubscriptionPackageDetailPageContent
        currentData={subscriptionPackage}
        isFetching={isFetching}
      />
    </PageLayout>
  );
}
